module.exports = __webpack_public_path__ + "static/media/ellas.734cbe20.png";